// Route table (apps/web-admin — admin-only, port 5175).
//
//   /            → Admin chat shell (chat-primary, H.3.4b). Investor
//                   surface lives in apps/web-investor on :5173.
//   /admin       → retired (H.3.4b); redirects to / so bookmarks don't 404.
//   /officer     → Compliance officer notebook (§5.4–5.5)
//   /preview/*    → Preview (Editor Phase 1) — read-only MDXEditor over
//                   any cell in content/. No save adapter, no AI.
//                   Source: docs/plan/PHASE_E1_EDITOR_READONLY.md.
//   /studio/*     → Studio (Editor Phase 2) — editable MDXEditor +
//                   tabbed Source/Preview/Diff + Publish modal. Mounts
//                   <TemplateStudio> with FsGitAdapter against the
//                   projector. Auth-gated (server-side ACL on
//                   /studio/save · /publish · /diff requires admin
//                   role; client-side UX gate hides the editor for
//                   unauthenticated visitors).
//                   Source: docs/plan/PHASE_E2_EDITOR_EDITABLE.md.

import { createBrowserRouter, Navigate } from 'react-router-dom';
import { RequireAdmin } from '@rmint/shell';

export const router = createBrowserRouter([
  {
    path: '/',
    lazy: async () => {
      const { Layout } = await import('./routes/Layout');
      return { Component: Layout };
    },
    children: [
      {
        index: true,
        lazy: async () => {
          const { AdminChat } = await import('./routes/Chat');
          return {
            Component: () => (
              <RequireAdmin>
                <AdminChat />
              </RequireAdmin>
            ),
          };
        },
      },
      {
        // /admin retired (H.3.4b) — collapsed into the chat shell at /.
        // Redirect so existing bookmarks land on the chat surface.
        path: 'admin',
        element: <Navigate to="/" replace />,
      },
      {
        path: 'officer',
        lazy: async () => {
          const { Officer } = await import('./routes/Officer');
          return {
            Component: () => (
              <RequireAdmin>
                <Officer />
              </RequireAdmin>
            ),
          };
        },
      },
      {
        // Splat route — cell paths contain slashes (e.g.
        // `subscribe/sign.ready.md`), so we match the suffix via `*`
        // and read it back with `useParams()['*']` inside Preview.
        path: 'preview/*',
        lazy: async () => {
          const { Preview } = await import('./routes/Preview');
          return {
            Component: () => (
              <RequireAdmin>
                <Preview />
              </RequireAdmin>
            ),
          };
        },
      },
      {
        // Splat route — same shape as /preview/*; cellPath is read
        // back with `useParams()['*']` inside Studio.
        path: 'studio/*',
        lazy: async () => {
          const { Studio } = await import('./routes/Studio');
          return {
            Component: () => (
              <RequireAdmin>
                <Studio />
              </RequireAdmin>
            ),
          };
        },
      },
    ],
  },
]);
